import { v4 as uuidv4 } from 'uuid'

import { setCookie } from '@core/helpers/cookies'
import { createTTL } from '@core/helpers/date'

const createCookieExpirationDate = (expirationDate) =>
  createTTL({ milliseconds: expirationDate }).toUTCString()

export const createCorrelationId = () => uuidv4()

export const getCorrelationId = (cookies, cookie) =>
  cookies[cookie.name] || createCorrelationId()

/**
 *
 * @param {String} visitorId uuid
 * @param {Object} res
 */
export const refreshCorrelationIdCookie = (cookie, value, res = {}) => {
  const expirationDate = createCookieExpirationDate(cookie.expiration)
  if (process.client) {
    setCookie(cookie.name, value, { expires: expirationDate })
  } else {
    res.setHeader('Set-Cookie', [
      `${cookie.name}=${value}; expires=${expirationDate}`,
    ])
  }
}
